module.exports = __webpack_public_path__ + "img/poster.7f33ee20.png";